import { useMemo } from 'react';
import { useSessionStorage } from 'usehooks-ts';
import { SelectedMultiOption } from '@weareopenr/component-library/build/components/MultiSelect/utilities';
import { useExternalSystems } from 'src/hooks/useExternalSystems/useExternalSystems';
import { getChannelLabel, getPricingChannels } from 'src/helpers/channels/getPricingChannels';
import { CHANNEL_FILTER_KEY } from 'src/constants';

export const useChannelFilter = () => {
  const { data: externalSystems, isLoading } = useExternalSystems();
  const [storedChannels, setSearchChannels] = useSessionStorage<string[]>(CHANNEL_FILTER_KEY, []);

  const pricingChannels = useMemo(() => getPricingChannels(externalSystems), [externalSystems]);

  const channelOptions: SelectedMultiOption[] = useMemo(
    () =>
      pricingChannels.map((channel, index) => ({
        id: channel.extensionInstanceId,
        label: getChannelLabel(channel),
        display_order: index,
      })),
    [pricingChannels],
  );

  const searchChannels = useMemo(
    () => storedChannels.filter((id) => pricingChannels.some(({ extensionInstanceId }) => extensionInstanceId === id)),
    [storedChannels, pricingChannels],
  );

  const visibleChannels = useMemo(
    () =>
      searchChannels.length > 0
        ? pricingChannels.filter(({ extensionInstanceId }) => searchChannels.includes(extensionInstanceId))
        : pricingChannels,
    [pricingChannels, searchChannels],
  );

  return {
    pricingChannels,
    visibleChannels,
    channelOptions,
    searchChannels,
    setSearchChannels,
    isLoading,
  };
};
